import { useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";

export const ThreeDSecureFrame = ({
  decodedHtml,
  onClose,
  onCancel,
}: {
  decodedHtml: string;
  onClose: () => void;
  onCancel: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Dialog
      open={!!decodedHtml}
      onClose={(event, reason) => {
        // Prevent closing on backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent sx={{ p: 0, position: "relative", minHeight: 500 }}>
        {/* Cancel Button */}
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
          }}
        >
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onCancel}
          >
            Cancel Payment
          </Button>
        </Box>

        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          >
            <CircularProgress />
          </Box>
        )}

        <iframe
          srcDoc={decodedHtml}
          style={{
            width: "100%",
            height: "500px",
            border: "none",
          }}
          title="3D Secure Authentication"
          onLoad={() => setIsLoading(false)}
          sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation"
        />
      </DialogContent>
    </Dialog>
  );
};
